import Editor from "Components/Form/Editor/Editor";
import React, { useEffect, useState } from "react";
import { Card, CardBody, CardTitle } from "reactstrap";
import Spinner from "Components/UI/Spinner";
import { getAdminSettings, updateAdminSettings } from "helpers/API Calls/System & Settings/Admin Settings";

function DocumentForm({searchKey, title}) {
  const [content, setContent] = useState("");
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [data, setData] = useState<any>(null);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const response = await getAdminSettings('key=' + searchKey);
      if (response.success) {
        const doc_data = response.data?.[0];
        setData(doc_data);
        setContent(doc_data?.value);
      }
      setIsLoading(false);
    };
    fetchData();
  }, [searchKey]);

  const onSubmit = async () => {
    setIsSubmitting(true);
    const redData = [{
      id: data.id,
      key: data.key,
      value: content,
    }];
    await updateAdminSettings({'settings': redData});
    setIsSubmitting(false);
  };

  return (
    isLoading ? <div className="position-relative vh-100"><Spinner/></div>
        :
    <Card>
        <CardBody>
        <CardTitle tag="h4" className="mb-4">
            {title}
        </CardTitle>
        <div className="mb-3">
            <Editor content={content} setContent={setContent} />
        </div>
        <div className="text-end mt-3">
            <button className="btn btn-primary" onClick={onSubmit}>
            {isSubmitting ? "Update..." : "Update Document"}
            </button>
        </div>
        </CardBody>
    </Card>
  );
}

export default DocumentForm;
